import { useTranslation } from 'react-i18next'
import { cn } from '@/shared/libs/cn'
import { Switch } from '@/shared/ui/switch'

interface PublishStatusSwitchProps {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  className?: string
}

/** Active / save-as-draft switch shown on create forms (an existing item is (de)activated from its list). */
export function PublishStatusSwitch({
  checked,
  onCheckedChange,
  className,
}: PublishStatusSwitchProps) {
  const { t } = useTranslation()

  return (
    <div
      className={cn(
        'mt-6 flex items-center justify-between rounded-lg border border-zinc-200 bg-zinc-50/60 px-4 py-3',
        className,
      )}
    >
      <div>
        <p className="text-sm font-medium text-zinc-800">{t('common.status')}</p>
        <p className="text-xs text-zinc-500">
          {checked ? t('common.active') : t('common.saveAsDraft')}
        </p>
      </div>
      <Switch checked={checked} onCheckedChange={onCheckedChange} />
    </div>
  )
}
